global.$ = global.jQuery = window.$ = window.jQuery = require('jquery');
window.Popper = require('popper.js');
require('bootstrap');
window.moment = require('moment');

import 'select2/dist/js/select2.full';
import 'select2/dist/css/select2.css';
import 'nestable2/dist/jquery.nestable.min.js'
import 'nestable2/dist/jquery.nestable.min.css'
import 'jquery-migrate/dist/jquery-migrate';
import 'jquery-ui/ui/widgets/autocomplete';
import 'jquery-ui/ui/widgets/datepicker';
import 'jquery-ui/ui/widgets/dialog';
import 'jquery-ui/ui/widgets/draggable';
import 'jquery-ui/ui/widgets/droppable';
import 'jquery-ui/ui/widgets/sortable';
import 'jquery-ui/ui/widgets/tabs';
import 'jquery-ui/ui/widgets/tooltip';
import 'jquery-ui/ui/effects/effect-blind';

import 'bootstrap-table/dist/extensions/sticky-header/bootstrap-table-sticky-header.css';
import 'bootstrap-table/dist/extensions/group-by-v2/bootstrap-table-group-by.css';
import 'bootstrap-table/dist/bootstrap-table';
import 'bootstrap-table/dist/bootstrap-table-locale-all';
import 'bootstrap-table/dist/extensions/mobile/bootstrap-table-mobile';
import 'bootstrap-table/dist/extensions/group-by-v2/bootstrap-table-group-by';
import 'bootstrap-table/dist/extensions/sticky-header/bootstrap-table-sticky-header';
import 'bootstrap-table/dist/extensions/cookie/bootstrap-table-cookie';
import 'bootstrap-table/dist/extensions/reorder-rows/bootstrap-table-reorder-rows';

import 'tablesorter/dist/js/jquery.tablesorter.min';
import 'nestable2/jquery.nestable';


import Sortable from 'html5sortable/dist/html5sortable.es';
window.Sortable = Sortable;
import * as echarts from 'echarts';
import Echo from 'laravel-echo';

window.Pusher = require('pusher-js');

require("tablednd/dist/jquery.tablednd.1.0.5");

import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";

import html2canvas from "html2canvas";
global.htmlTocanvas = html2canvas;

if (process.env.NODE_ENV === 'production') {
    Sentry.init({
        dsn: "https://3698be5bd3794465aacce4e9a203fbec@o457102.ingest.sentry.io/5452672",

        // Alternatively, use `process.env.npm_package_version` for a dynamic release version
        // if your build tool supports it.
        integrations: [new Integrations.BrowserTracing()],

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 0,
    });
}

import * as  mobiscroll from '@mobiscroll/javascript';

global.echarts	= echarts;
global.mobiscroll	= mobiscroll;


mobiscroll.setOptions({
	locale: mobiscroll.localeNl,
	theme: "material",
	themeVariant: "light",
});
mobiscroll.registerComponent(mobiscroll.Button);
mobiscroll.registerComponent(mobiscroll.CalendarNav);
mobiscroll.registerComponent(mobiscroll.CalendarToday);
mobiscroll.registerComponent(mobiscroll.CalendarPrev);
mobiscroll.registerComponent(mobiscroll.CalendarNext);
mobiscroll.registerComponent(mobiscroll.Datepicker);
mobiscroll.registerComponent(mobiscroll.Dropdown);
mobiscroll.registerComponent(mobiscroll.Input);
mobiscroll.registerComponent(mobiscroll.Switch);
mobiscroll.registerComponent(mobiscroll.Page);
mobiscroll.registerComponent(mobiscroll.Segmented);

import { library, findIconDefinition, icon} from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/pro-solid-svg-icons'
import { far } from '@fortawesome/pro-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'

library.add(fas, far, fab)

global.findIconDefinition = findIconDefinition;
global.icon = icon;

global.Echo = Echo;

import {Html5QrcodeScanner, Html5QrcodeScanType} from "html5-qrcode";
import {Html5QrcodeScannerStrings} from "html5-qrcode/esm/strings";

global.Html5QrcodeScanner			= Html5QrcodeScanner;
global.Html5QrcodeScanType			= Html5QrcodeScanType;
global.Html5QrcodeScannerStrings	= Html5QrcodeScannerStrings;

function initializeGlobalSearch() {
	const $globalSearch = $(":input[name=globalsearch]");

	if ($globalSearch.length === 0) {
		return;
	}

	$globalSearch.off("select2:select.eoGlobalSearch");

	if ($globalSearch.hasClass("select2-hidden-accessible")) {
		$globalSearch.select2("destroy");
	}

	$globalSearch.select2({
        ajax:	{
            url:	"/js/json/globalsearch.php",
            data: function (params) {
                return {
                    term:	 				params.term
                };
            },
            processResults:	function(data){
                return data;
            },
            delay: 				250,
            cache: 				true
        },
        minimumInputLength: 3,
		dropdownCssClass: 'eoSearch',
        templateResult: function(result){
            var text = '<span class="text">'+result.text+'</span>';
            if(result.subtext){
                text += '<span class="subtext">'+result.subtext+'</span>';
            }
            return $(text);
        }
	}).on("select2:select.eoGlobalSearch", function(e){
        var data = e.params.data;
        if(data.url){
			if($(this).data("is-consolidation") === true){
				const win = window.open(data.url);
				if(win){
					win.focus();
				} else {
            		document.location.href=data.url;
				}
			} else {
            	document.location.href=data.url;
			}
        }
    });
}

$(initializeGlobalSearch);
document.addEventListener("livewire:navigated", initializeGlobalSearch);

window.safeParseJSON = function(value, defaultValue) {
	try {
		return JSON.parse(value) || defaultValue;
	} catch {
		return defaultValue;
	}
};

window.PREVIOUS_ROUTES_KEY = "previous_routes";

let currentUrl   = window.location.href;
let currentRoute = (window.currentRoute || window.location.pathname).toLowerCase();
const framePath  = "frame/";
let navType = "navigate";
let isChromium = navigator.userAgentData?.brands?.some(b => b.brand === "Chromium");

try {
	// Navigation type defensief bepalen
	const navEntries = (performance && performance.getEntriesByType)
		? performance.getEntriesByType("navigation")
		: [];
	navType = (navEntries && navEntries[0] && navEntries[0].type) || "navigate";
} catch (_) { /* keep default */ }

const navBackForward = "back_forward";
const navReload      = "reload";
let ignorePopstate= false;

// Helpers
function isFrame(urlOrPath) {
	return (urlOrPath || "").toLowerCase().indexOf(framePath) !== -1;
}
function lastItem(arr) {
	return arr && arr.length ? arr[arr.length - 1] : undefined;
}

// Gaat `steps` terug in de browsergeschiedenis.
// Wacht na `popstate` nog kort voordat de callback draait, omdat de browser
// history en afgeleide navigatiestatus dan nog niet altijd volledig stabiel zijn.
// Als `popstate` uitblijft, wordt het na de `timeout` alsnog afgerond.
function silentHistoryBack(steps = 1, callback, timeout = 250, settleDelay = 50) {
	if (ignorePopstate) return;

	ignorePopstate = true;
	let finishing = false;
	let finishTimeoutId;


	const finish = () => {
		if (finishing) return;
		finishing = true;
		window.removeEventListener("popstate", finish);
		clearTimeout(finishTimeoutId);

		setTimeout(() => {
			ignorePopstate = false;
			callback?.();
		}, settleDelay);
	};

	window.addEventListener("popstate", finish);
	finishTimeoutId = setTimeout(finish, timeout);
	history.go(-steps);
}

// Verwerkt de applicatiebrede `popstate`-afhandeling op één plek.
function handleHistoryPopstate(state) {
	let forwardUrl = state?.forwardUrl;
	if(forwardUrl){
		// Vooruit navigatie
		silentHistoryBack(1, () => location.assign(forwardUrl));
		return;
	}

	// Terug navigatie
	let previousRoutes = safeParseJSON(sessionStorage.getItem(PREVIOUS_ROUTES_KEY), [])
		.filter(r => r?.route && r?.url);
	if (previousRoutes.length === 0) return;

	if(state !== null) {
		const previousRoute = previousRoutes[previousRoutes.length - 1];
		let stepsBack = Math.max(previousRoute?.stepsBack, 0);
		let previousUrl = null;
		let key = null;

		// Als we op dezelfde route zitten, haal laatste entry alvast weg
		if (currentRoute === previousRoute.route) {
			previousRoutes.splice(previousRoutes.length - 1, 1);
			if(previousRoutes.length) {
				previousRoutes[previousRoutes.length - 1].forwardUrl = currentUrl;
				previousUrl = previousRoutes[previousRoutes.length - 1].url;
				key = previousRoutes[previousRoutes.length - 1].key;
			}
			sessionStorage.setItem(PREVIOUS_ROUTES_KEY, JSON.stringify(previousRoutes));
		}

		// Probeert via de Navigation API gericht naar een eerdere history entry te navigeren;
		// valt terug op silentHistoryBack als dat niet mogelijk is
		if (key !== null) {
			if (
				'navigation' in window &&
				typeof navigation.entries === 'function' &&
				typeof navigation.traverseTo === 'function'
			) {
				for (const entry of navigation.entries().filter(e => e.key === key || e.url === previousUrl).reverse()) {
					try {
						const transition = navigation.traverseTo(entry.key);
						transition.committed.catch(() => {
							silentHistoryBack(stepsBack);
						});
						return;
					} catch {}
				}
			}
		}

		// centrale fallback als gerichte navigatie niet mogelijk is of mislukt
		silentHistoryBack(stepsBack);
	} else {
		// Afhandeling voor chrome popstate #hash navigatie
		window.registerNavigation(0, true)
	}
}

window.navigateBack = function () {
	handleHistoryPopstate({});
};

if (currentUrl.indexOf(framePath) === -1 && currentRoute.indexOf(framePath) === -1) {
	window.registerNavigation = async function(stepsBack = 0, pushState = true, observeDelay = 250) {
		let previousRoutes = safeParseJSON(sessionStorage.getItem(PREVIOUS_ROUTES_KEY), [])
			.filter(r => r?.route && r?.url);

		let forwardUrl = "";
		let returnUrl = "";
		let existingIndex = -1;
		let historyIndex = history.length;

		// Laatste overeenkomende index ophalen.
		for (let i = previousRoutes.length - 1; i >= 0; i--) {
			if (previousRoutes[i].route === currentRoute) {
				existingIndex = i;
				break;
			}
		}
		if (existingIndex !== -1) {
			const isLast= (existingIndex + 1) === previousRoutes.length;
			const previousRoute = previousRoutes[existingIndex];
			const previousstepsBack = (previousRoute.stepsBack || 0);

			// Historie fixen met browser terug acties
			if (navType === navBackForward) {
				forwardUrl = (previousRoute.forwardUrl || "");
				previousRoutes = previousRoutes.slice(0, existingIndex);
			} else if (isLast === true) {
				previousRoutes.splice(existingIndex, 1);
			}

			if (navType === navBackForward) {
				// Afhandeling op vooruit/achteruit navigatie
				stepsBack += previousstepsBack;
			} else if (isLast === true) {
				// Afhandeling op route navigatie
				if(pushState){
					returnUrl = previousRoutes.length ? lastItem(previousRoutes).url : '';
				}

				// Wacht kort zodat history-updates, route-afhandeling en afgeleide terugnavigatie consistent zijn
				await new Promise(resolve => {
					setTimeout(resolve, observeDelay);
				});

				historyIndex = previousRoute.index;
				stepsBack = history.length - historyIndex;
			}
		}

		let pushUrl = window.location.href;
		if (pushState) {
			// Navigatie op route niveau afgehandeld
			if(returnUrl){
				if(!history.state?.replaceUrl){
					window.history.replaceState({ _id: Date.now()+"_replace_"+stepsBack, returnUrl: returnUrl, stepsBack }, "", pushUrl+"#");
				}
				window.history.pushState({ _id: Date.now()+"_push_"+stepsBack, pushUrl: pushUrl,  stepsBack }, "", pushUrl);
				stepsBack += 1;
			} else {
				window.history.replaceState({ _id: Date.now()+"_replace_"+stepsBack, replaceUrl: pushUrl,  stepsBack }, "", pushUrl);
				// Eenmalige vooruit
				if(forwardUrl){
					window.addEventListener("DOMContentLoaded", function() {
						window.history.pushState({_id: Date.now() + "_forward_" + stepsBack, forwardUrl: forwardUrl, stepsBack}, "", forwardUrl);
						silentHistoryBack();
						forwardUrl = "";
					}, { once: true });
				}
			}
		}

		const key = ('navigation' in window && navigation.currentEntry?.key) || null;
		previousRoutes.push({
			key: key,
			index: historyIndex,
			route: currentRoute,
			url: pushUrl,
			stepsBack: Math.max(stepsBack,0),
			forwardUrl: forwardUrl,
		});
		sessionStorage.setItem(PREVIOUS_ROUTES_KEY, JSON.stringify(previousRoutes));
	}
}

// Init-registratie (behalve bij reloads)
if (navType !== navReload) {
	const isInFrame = isFrame(currentUrl) || isFrame(currentRoute);

	if (isInFrame && window.frameElement && typeof parent.registerNavigation === "function") {
		let hasCompleted = false;

		const finalizeNavigation = () => {
			if (hasCompleted) return;
			hasCompleted = true;
			parent.registerNavigation(0, true);
		};

		window.addEventListener("load", finalizeNavigation, { once: true });

		(function pollUntilComplete() {
			if (hasCompleted) return;
			if (document.readyState === "complete") return finalizeNavigation();
			setTimeout(pollUntilComplete, 50);
		})();
	}
	else if (!isInFrame) {
		registerNavigation(0, true);
	}
}

$(function () {
 	// Globale afhandeling voor anchors met href="#"
    // Doel: hash‑navigatie (en extra history‑items) voorkomen zonder onclick‑logica te beïnvloeden.
    // Opt-out: voeg data-allow-hash="true" toe om standaard hash‑gedrag toe te staan.
    $(document).on("click", "a[href='#']", function (e) {
        if (this.dataset && this.dataset.allowHash === "true") {
            return; // laat standaard gedrag toe
        }
        e.preventDefault();
    });


	// Nieuwe reservering: Quicklinks actief maken bij scrollen
    // Nieuwe reservering: Naar content scrollen
	$(".quicklinks a[href^='#']").on("click", function (e) {
        e.preventDefault();
        $(document).off("scroll");

        // Actieve classes toevoegen en verwijderen
		$("a").each(function () {
			$(this).parent().removeClass("active");
		});
		$(this).parent().addClass("active");

        // Scrollen naar juiste div content
		const target = $(this.hash);
		const targetOffset = target.offset().top;
		const currentOffset = $("body").scrollTop();
		const offset = targetOffset + currentOffset;

        $("html, body").stop().animate({
            'scrollTop': offset,
        }, 250, function () {
            $(document).on("scroll", onScroll);
        });
    });

    const $responsiveMessage = $(".responsiveMessage");
    if($responsiveMessage.length > 0) {
        $responsiveMessage.on("click", " .alert-close", function() {
            $responsiveMessage.addClass("hide-message");
        });
    }


	// Functie: Bereken de ruimte voor het menu op mobiel
	const menuOffset = () => {
		if ($("body").hasClass("fi-panel-app")) {
			// Filament's mobile menu is fixed to the viewport; include the banner above the header.
			return $("#shortcuts")[0].getBoundingClientRect().bottom;
		}
		return $("#header-wrapper").outerHeight() + $("#shortcuts").outerHeight();
	};

	$(document)
		.off("click.eoMobileNavigation", ".togglemenu")
		.on("click.eoMobileNavigation", ".togglemenu", function() {
		$(this).toggleClass("menu-active");
		$("#shortcuts, #navbar").toggleClass("show");
		$("#navbar").css("top", menuOffset());
		$("body").toggleClass("prevent-scrolling");
		$("#placeholder").toggleClass("navbar-open");
	});

	$(window).off("resize.eoMobileNavigation").on("resize.eoMobileNavigation", function () {
		if ($("body").hasClass("fi-panel-app") && (window.innerWidth >= 992 || $("#navbar").hasClass("show"))) {
			$("#navbar").css("top", window.innerWidth < 992 ? menuOffset() : "");
		}
	});

	$(document).on("click", ".toggleActions", function () {
		$(this).toggleClass("open").closest(".header").toggleClass("open");
	});

    if($(window).width() < 992) {
        const menuActive = $.cookie("active_menu");
		$(document)
			.off("click.eoMobileNavigation", "#navbar > ul > li > a")
			.on("click.eoMobileNavigation", "#navbar > ul > li > a", function () {
            if ($(this).parent().hasClass("active")) {
                $(this).parent().removeClass("active");
                $.cookie("active_menu", null);
            } else {
                $(this).parent().addClass("active");
                $.cookie("active_menu", $(this).attr("class"));
            }
		});

        if (typeof $.cookie("active_menu") === typeof undefined){
            let $activeItem = $("#navbar > ul > li").find('a[class="' + menuActive + '"]');
            $activeItem.parent().addClass("active");
        }
    }

    $(window).on("scroll", function () {
        onScroll();
    });

    // Legena kunnen slepen door pagina, sluiten na klikken op X
    if($("#legenda").length > 0){
        $("#legenda").drags();
        $("#legenda .close").on("click", function () {
            $(this).parent().hide();
        });
    }

    // In select2 mogelijkheid maken om een background te tonen
    $('.multi-select-labels').select2({
        closeOnSelect: false,
        templateResult: function(option){
            var $option	= $(option.element);
            if(typeof $option.attr("data-background-color") !== typeof undefined) {
                var backgroundColor = $option.attr("data-background-color");
                return $("<span><span class='select2-item' style='background-color: "+backgroundColor+";'></span>"+option.text+"</span>");
            }
            return option.text;
        },
        templateSelection: function(option){
            var $option = $(option.element);
            if(typeof $option.attr("data-background-color") !== typeof undefined) {
                var backgroundColor = $option.attr("data-background-color");
                return $("<span><span class='select2-item' style='background-color: "+backgroundColor+";'></span>"+option.text+"</span>");
            }
            return option.text;
        }
    });

    // Relatietype met id 2 + 3 niet wegklikbaar kunnen maken (relatie toevoegen / edit etc)
    let $selectRelType = $("select[name='relation_type[]'");
    if($selectRelType.length > 0 ) {
        $("select[name='relation_type[]'").on("select2:unselecting", function (event) {
            if(event.params.args.data.id == 2 || event.params.args.data.id == 3) {
                event.preventDefault();
            }
        });
    }

    $(".result-wrapper .read-more").on("click", function (){
        $(this).parent().find('.list-group-item').show();
        $(this).hide();
    });

    // De 'Terug' button in de pop-up de huidige pop-up laten sluiten
    $(".terug .btn.terug").on("click", function(ev){
        ev.preventDefault();
		if($("body.popup-ui").length > 0){
			parent.$("body").removeClass("prevent-scrolling");
			var $closeBtn    = parent.$(".ui-dialog-titlebar-close");
            if($closeBtn.length > 0){
				$closeBtn.trigger("click");
            }
        }

		try {
			if(parent && parent.dhxWins){
				parent.$("body").removeClass("prevent-scrolling");
				var topWindowName   = parent.dhxWins.getTopmostWindow(false);
				if(topWindowName !== null){
					parent.dhxWins.window(topWindowName).close();
				}
			}
		} catch (e) {
			try {
				parent.postMessage("close-window", "*");
			} catch (e) {

			}
		}
    });

	window.addEventListener("message", (event) => {
		if(event.data === "close-window"){
			if(typeof dhxWins !== typeof undefined){
				const topWindowName = dhxWins.getTopmostWindow(false);
				if(topWindowName !== null){
					dhxWins.window(topWindowName).close();
				}
			}
		}
	}, false);

    // Pagina als snelkoppeling aan favorieten toe kunnen voegen
    $(".makeshortcut").on("click", function(){
        var $this	= $(this);
        $.ajax({
            type: "POST",
            url: "js/json/makeshortcut.php",
            data: {
                right_id: 	$this.attr("data-right-id"),
                name:		$this.attr("data-name"),
                conn_id:	$this.attr("data-conn-id")
            },
            success: function(data){
                $.eoprompt(data.message);
                if(data.added && data.added === true){
                    $(".add-to-favorites").addClass("active");
                } else {
                    $(".add-to-favorites").removeClass("active");
                }
            }
        });

        return false;
    });

    /*
     ** Om te voorkomen dat standaard zwart wordt opgeslagen, wordt de input color een tekst veld bij het laden
     *  Daarna wordt na de klik het veld weer een color selector
     */
    if($("input[type='color']").length > 0) {
        $("input[type='color']").each(function () {
            let inputColor = $(this).attr("value");
            if (inputColor === "#" || inputColor === "") {
                // Class nodig, zodat we later op basis van de class het veld leeg kunnen maken
                $(this).attr("value", "").addClass("emptyValue");
            } else {
                $(this).css("background-color", inputColor); // De gekozen kleur als background kleur op de input zetten
                inputClearValue($(this));
            }
            $(this).addClass("input-color").prop("type", "text"); // Verander type color naar type text

            $(this).on("change", function () {
                inputColorToText($(this));
                inputClearValue($(this));
            });
        });
        $(".input-color.emptyValue").val("");
        $(".input-color").on("click", function () {
            $(this).prop("type", "color").css("background-color", "");
        });
    }

    // Input color type naar text en achtergrond toevoegen + clear button tonen
    function inputColorToText($input) {
        let inputColor = $input.val();
        $input.addClass("input-color").prop("type", "text"); // Verander type color naar type text
        $input.css("background-color", inputColor); // De gekozen kleur als background kleur op de input zetten
    }

    // Button toevoegen om kleur weer uit input veld te verwijderen
    function inputClearValue($input) {
        $input.parent().append("<div title='Kleur leegmaken' class='resetCurrentColor'></div>"); // Reset knop maken zodat input leeg kan worden gemaakt
        let $resetColor = $(".resetCurrentColor");
        if($resetColor.length > 0) {
            $(".resetCurrentColor").on("click", function () {
                $(this).hide().siblings().attr("value", "").val("").css("background-color", ""); // Button verbergen en input leeg maken
            });
        }
    }

    //dummy element om het huidige scherm te focussen
    let $dummyinputfocus    = $("#dummyinputfocus");
    if($dummyinputfocus.length > 0){
        setTimeout(function(){
            $dummyinputfocus.focus();
        }, 50);

        $dummyinputfocus.on("focus", function(){
            $(this).blur();
        });
    }

    // Juiste item actief maken bij scrollen binnen nieuwe reservering pagina
    function onScroll(event){
        var scrollPos = $(document).scrollTop();
        if($(".quicklinks").length > 0) {
            $('.quicklinks a').each(function () {
                var currLink = $(this);
                var refElement = $(currLink.attr("href"));
                if (refElement.length && refElement.position().top <= scrollPos && refElement.position().top + refElement.height() > scrollPos) {
                    $('.quicklinks a').parent().removeClass("active");
                    currLink.parent().addClass("active");
                } else {
                    currLink.parent().removeClass("active");
                }
            });
        }
    }

	window.addEventListener("popstate", function (e) {
		if (isFrame(currentUrl) || isFrame(currentRoute) || ignorePopstate) {
			return;
		}

		handleHistoryPopstate(e.state);
	});

	$(window).on("message", function(e) {
	const eventData = e.originalEvent?.data;
		if (eventData === "open-frame-content") {
			$(".dhxwin_active.collapsed-iframe").css({
				"max-height": "unset",
				"box-shadow": "1px 1px 8px 2px #4c4c4c"
			});
			$(".dhxwins_mcover").css("opacity", ".6");
		} else if (eventData === "close-frame-content") {
			$(".dhxwin_active.collapsed-iframe").css(
				{
					"max-height": "46px",
					"box-shadow": "1px 1px 8px 0px #6f6f6f"
				});
			$(".dhxwins_mcover").css("opacity", ".3");
		}
	});


	$("body.framepage .header").on("click", function(c) {
		if (c.target !== this) {
			return;
		}
		const iframe = window.frameElement;
		if (!iframe) {
			return;
		}
		const dhxwinActive = iframe.closest(".dhxwin_active");
		if (!dhxwinActive) {
			return;
		}
		dhxwinActive.classList.add("collapsed-iframe");
		if ($(this).hasClass("collapsed")) {
			window.top.postMessage("open-frame-content", "*");
			$(this).removeClass("collapsed").css("margin-bottom", ".5rem");
			$("html").css("max-height", "unset");
			$(this).parent().removeClass("prevent-scrolling");
		} else {
			window.top.postMessage("close-frame-content", "*");
			$(this).addClass("collapsed").css("margin-bottom", "0");
			$("html").css("max-height", "46px");
			$(this).parent().addClass("prevent-scrolling");
		}
	});

});

String.prototype.trimLeft = function(charlist) {
  if (charlist === undefined)
    charlist = "\s";

  return this.replace(new RegExp("^[" + charlist + "]+"), "");
};

String.prototype.trimRight = function(charlist) {
  if (charlist === undefined)
    charlist = "\s";

  return this.replace(new RegExp("[" + charlist + "]+$"), "");
};

window.getParameterByName = function(name, url = window.location.href) {
	let params = (new URL(url)).searchParams;
	return params.get(name);
}

const echartLocaleNL = {
	time: {
		month: [
			"Januari", "Februari", "Maart", "April", "Mei", "Juni",
			"Juli", "Augustus", "September", "Oktober", "November", "December"
		],
		monthAbbr: [
			"Jan", "Feb", "Mrt", "Apr", "Mei", "Jun",
			"Jul", "Aug", "Sep", "Okt", "Nov", "Dec"
		],
		dayOfWeek: [
			"Zondag", "Maandag", "Dinsdag", "Woensdag", "Donderdag", "Vrijdag", "Zaterdag"
		],
		dayOfWeekAbbr: [
			"Zo", "Ma", "Di", "Wo", "Do", "Vr", "Za"
		]
	},
	legend: {
		selector: {
			all: "Alles",
			inverse: "v.v."
		}
	},
	toolbox: {
		brush: {
			title: {
				rect: "Vak Selectie",
				polygon: "Lasso Selectie",
				lineX: "Horizontale Selectie",
				lineY: "Verticale Selectie",
				keep: "Onthoudt Selectie",
				clear: "Wis Selectie"
			}
		},
		dataView: {
			title: "Data Weergave",
			lang: ["Data Weergave", "Sluiten", "Vernieuwen"]
		},
		dataZoom: {
			title: {
				zoom: "Schaal",
				back: "Schaal resetten"
			}
		},
		magicType: {
			title: {
				line: "Overschakelen naar lijn grafiek",
				bar: "Overschakelen naar balk grafiek",
				stack: "Vlak",
				tiled: "Heatmap"
			}
		},
		restore: {
			title: "Herstellen"
		},
		saveAsImage: {
			title: "Opslaan als afbeelding",
			lang: ["Opslaan via rechter muisknop"]
		}
	}
};
window.echarts.registerLocale('NL', echartLocaleNL);

import {
	handleDeleteError,
	reinitializeSelect2SelectElement,
	hexToRgb,
	initializeMobiScrollDatePicker,
	isDarkColor, escapeHtml
} from './default';
window.handleDeleteError = handleDeleteError;
window.reinitializeSelect2SelectElement = reinitializeSelect2SelectElement;
window.hexToRgb = hexToRgb;
window.initializeMobiScrollDatePicker = initializeMobiScrollDatePicker;
window.isDarkColor = isDarkColor;
window.escapeHtml = escapeHtml;
